import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ChevronRight } from '@xsolla/ui-icons';

export const CrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CrumbItemWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  flex: 0 1 auto;
`;

export const CrumbItem = styled(Link)`
  color: ${(props) => props.theme.colors.muted};
  text-decoration: none;
  ${(p) => p.theme.typography.title};
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  :hover {
    color: ${(props) => props.theme.colors.brand};
  }
`;

export const NextCrumbIcon = styled(ChevronRight)`
  margin-right: 8px;
  color: ${(props) => props.theme.colors.muted};
`;

export const LastCrumbItem = styled.div`
  color: ${(props) => props.theme.colors.text};
  ${(p) => p.theme.typography.title};
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
